module.exports = __webpack_public_path__ + "static/media/customer_portal.31fcfaf8.png";